export const update = {
  form: {
    quantity: 'Quantity',
    price: 'Price',
    name: 'Name',
    update: 'Update',
    requireQuantity: 'Please input quantity',
    requirePrice: 'Please input price',
    priceUnit: '¥',
    quantityUnit: 'gram',
    cancel: 'Cancel',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Edit Detergent History',
    back: 'Back',
  },
}
